// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutus_container__3xQ46","container1":"aboutus_container1__1cBeY"};